import { Checkbox, Stack, Text, Group, Flex } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

type Props = {
  form: any;
};

const Component = ({ form }: Props) => {
  const { t } = useTranslation();
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [noneSelected, setNoneSelected] = useState(false);

  const trainingOptions = ["SP_002A", "SP_002B", "SP_002C"];
  const noneOption = "SP_002_NONE";

  useEffect(() => {
    if (noneSelected) {
      // When "Ninguna de las anteriores" is selected, set N.A values
      form.setFieldValue("SP_002_A_C_haSidoCapacitado", ["N.A"]);
    } else {
      const trainingValues = selectedValues.filter((value) =>
        trainingOptions.includes(value)
      );
      form.setFieldValue("SP_002_A_C_haSidoCapacitado", trainingValues);
    }
  }, [selectedValues, noneSelected]);

  const handleCheckboxChange = (value: string) => {
    if (value === noneOption) {
      if (noneSelected) {
        setNoneSelected(false);
        setSelectedValues([]);
      } else {
        setNoneSelected(true);
        setSelectedValues([noneOption]);
      }
    } else {
      setNoneSelected(false);
      if (selectedValues.includes(value)) {
        setSelectedValues((prev) =>
          prev.filter((v) => v !== value && v !== noneOption)
        );
      } else {
        setSelectedValues((prev) => [
          ...prev.filter((v) => v !== noneOption),
          value,
        ]);
      }
    }
  };

  return (
    <Stack spacing="xs">
      <Text fw={500} size="sm" color="gray.8">
        ¿En los últimos 12 meses has recibido capacitación en alguno de estos
        temas?
      </Text>
      <Text fz="xs" color="red">
        *Debes seleccionar al menos una opción.
      </Text>
      <Stack spacing={4}>
        <Checkbox
          key={"SP_002A"}
          label="Acoso Sexual"
          checked={selectedValues.includes("SP_002A")}
          disabled={noneSelected}
          onChange={() => handleCheckboxChange("SP_002A")}
          size="sm"
          color="gray"
          styles={{
            body: { alignItems: "center" },
            label: {
              lineHeight: 1.0,
              minHeight: "2.0rem",
              display: "flex",
              alignItems: "center",
            },
          }}
        />
        <Checkbox
          key={"SP_002B"}
          label="Acoso Laboral"
          checked={selectedValues.includes("SP_002B")}
          disabled={noneSelected}
          onChange={() => handleCheckboxChange("SP_002B")}
          size="sm"
          color="gray"
          styles={{
            body: { alignItems: "center" },
            label: {
              lineHeight: 1.0,
              minHeight: "2.0rem",
              display: "flex",
              alignItems: "center",
            },
          }}
        />
        <Checkbox
          key={"SP_002C"}
          label="Violencia en el trabajo"
          checked={selectedValues.includes("SP_002C")}
          disabled={noneSelected}
          onChange={() => handleCheckboxChange("SP_002C")}
          size="sm"
          color="gray"
          styles={{
            body: { alignItems: "center" },
            label: {
              lineHeight: 1.0,
              minHeight: "2.0rem",
              display: "flex",
              alignItems: "center",
            },
          }}
        />
        <Checkbox
          label="Ninguna de las anteriores"
          checked={noneSelected}
          onChange={() => handleCheckboxChange(noneOption)}
          size="sm"
          color="gray"
          styles={{
            body: { alignItems: "center" },
            label: {
              lineHeight: 1.0,
              minHeight: "2.0rem",
              display: "flex",
              alignItems: "center",
            },
          }}
        />
      </Stack>
    </Stack>
  );
};

export default Component;
